var error = new Array();
// lang en
error['en_US'] = new Array();
error['en_US']['noNetWork'] = "Unable to connect server , please try again later.";
error['en_US']['imgLimit'] = "Image size can not exceed 3 M";
error['en_US']['-1'] = "Failed";
error['en_US']['-2'] = "errorCode:-2 null Error Message";
error['en_US']['-3'] = "errorCode:-3 null Error Message";
error['en_US']['-4'] = "errorCode:-4 null Error Message";
error['en_US']['-5'] = "errorCode:-5 null Error Message";
error['en_US']['-6'] = "errorCode:-6 null Error Message";
error['en_US']['-7'] = "errorCode:-7 null Error Message";
error['en_US']['-100'] = "Already exists punch card, cannot creat.";
error['en_US']['-101'] = "rewardContent length more than 500 charset.";
error['en_US']['-102'] = "termsConditionLen length more than 3000 charset.";
error['en_US']['-103'] = "punchCardType out of range.";
error['en_US']['-200'] = "errorCode:-200 null Error Message";
error['en_US']['-201'] = "errorCode:-201 null Error Message";
error['en_US']['-300'] = "title length more than 300 charset.";
error['en_US']['-301'] = "description length more than 500 charset.";
error['en_US']['-302'] = "termsConditions length more than 3000 charset.";
error['en_US']['-400'] = "Warning Not valid Code.";
error['en_US']['-401'] = "User coupon qrCode is not exists.";
error['en_US']['-402'] = "User punch Card qrCode is not exists.";
error['en_US']['-403'] = "User qrCode is not exists.";
error['en_US']['-500'] = "Email already exists";
error['en_US']['-1402'] = "Member tier info already exist.";
error['en_US']['-1401'] = "Member tier status update fail.";
error['en_US']['cancelSuccess'] = "Successfully cancelled";
error['en_US']['punchcardEdit'] = "You are going to edit details of a current stamp card, the updated information will override the old data on existing stamp cards. Are you sure?";
error['en_US']['punchcardTerminate'] = "You are going to terminate an issued stamp card. Users will not be able to collect stamps or redeem rewards with it. Are you sure";
error['en_US']['CouponTerminate'] = "You are going to terminate an issued coupon. Users will not be able to collect or redeem it. Are you sure?";
error['en_US']['inputEmpty'] = "Something is missing.  Please check your inputs and try again.";
error['en_US']['EditPunchcard'] = "Confirm to edit";
error['en_US']['TerminatePunchcard'] = "Confirm to terminate";
error['en_US']['TerminateCoupon'] = "Confirm to terminate";
// lang cn
error['zh_CN'] = new Array();
error['zh_CN']['noNetWork'] = "服务器繁忙，请稍后再试";
error['zh_CN']['imgLimit'] = "圖片大小不能超過3M。";
error['zh_CN']['-1'] = "服务器繁忙，请稍后再试";
error['zh_CN']['-2'] = "输入参数不能为空";
error['zh_CN']['-3'] = "errorCode:-3 null Error Message _cn";
error['zh_CN']['-4'] = "errorCode:-4 null Error Message _cn";
error['zh_CN']['-5'] = "errorCode:-5 null Error Message _cn";
error['zh_CN']['-6'] = "errorCode:-6 null Error Message _cn";
error['zh_CN']['-7'] = "errorCode:-7 null Error Message _cn";
error['zh_CN']['-100'] = "this entityId have active punch card,can not change status. _cn";
error['zh_CN']['-101'] = "rewardContent length more than 500 charset. _cn";
error['zh_CN']['-102'] = "termsConditionLen length more than 3000 charset. _cn";
error['zh_CN']['-103'] = "punchCardType out of range. _cn";
error['zh_CN']['-200'] = "文档不存在";
error['zh_CN']['-201'] = "文档转换错误";
error['zh_CN']['-300'] = "title length more than 300 charset. _cn";
error['zh_CN']['-301'] = "description length more than 500 charset. _cn";
error['zh_CN']['-302'] = "termsConditions length more than 3000 charset. _cn";
error['zh_CN']['-400'] = "Warning Not valid Code. _cn";
error['zh_CN']['-401'] = "User coupon qrCode is not exists. _cn";
error['zh_CN']['-402'] = "User punch Card qrCode is not exists. _cn";
error['zh_CN']['-403'] = "User qrCode is not exists. _cn";
error['zh_CN']['-500'] = "Email already exists _cn";
error['zh_CN']['-1402'] = "Member tier info already exist._cn";
error['zh_CN']['-1401'] = "Member tier status update fail._cn";
error['zh_CN']['cancelSuccess'] = "已成功取消";
error['zh_CN']['punchcardEdit'] = "印花卡已經推出，已發放的印花卡會因應你所作出的改動而更新，確定要修改其內容?";
error['zh_CN']['punchcardTerminate'] = "印花卡已經推出，會員將無法繼續收集印花或兌換獎賞，確定要移除印花卡?";
error['zh_CN']['inputEmpty'] = "Something is missing.  Please check your inputs and try again.";
error['zh_CN']['EditPunchcard'] = "確定修改";
error['zh_CN']['TerminatePunchcard'] = "確定並移除";
error['zh_CN']['CouponTerminate'] = "優惠券已經推出，移除後會員將無法憑優惠券兌換獎賞，確定要移除優惠券?";
error['zh_CN']['TerminateCoupon'] = "確定並移除";

export default {
    error
}